export default __webpack_public_path__ + "static/media/participants.71c4f65d.svg";